<div class="container-fluid server-down-wrapper">
    <div class="message">
        <h2>Sorry!</h2>
        <p>We’re down due to maintenance.<br>Please check again soon.</p>
    </div>
</div>